import { WidgetType } from '../../Widget';
import {
  _warray,
  _winput,
  _wselect,
  _wsubsection,
  createTestTree,
} from '../widgetsTestUtils';

export const storybookTestTreeWidgets = {
  listChildName: _winput('c061_nome_figlio'),
};

export const storybookTestTree = createTestTree(
  _winput('c01_nome'),
  _winput('c05_bool_01', WidgetType.Boolean),
  _winput('c05_bool_02', WidgetType.Boolean),
  _winput('c02_cognome'),
  _winput('c03_data_di_nascita', WidgetType.Date),
  _winput('c03_data_di_iscrizione', WidgetType.Date),
  _winput('c04_anni', WidgetType.Number),
  _warray(
    'c06_figli',
    storybookTestTreeWidgets.listChildName,
    _winput('c062_cognome_figlio'),
    _winput('c063_data_di_nascita_figlio', WidgetType.Date),
    _winput('c064_anni_figlio', WidgetType.Number),
  ),
  _wselect('c07_select', ['a', 'b', 'c']),
  _wselect('c08_select', ['Opzione A', 'Opzione B', 'Opzione C']),
  _wsubsection(
    'c09_subsection',
    _winput('c091_nome_sottosez'),
    _winput('c092_cognome_sottosez'),
  ),
);
